import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon, TargetIcon, ChevronRightIcon } from 'lucide-react';
export function QuickLinks() {
  return <div className="w-full pb-12 md:pb-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1294">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1295">
        <div data-id="element-1296">
          <h2 className="text-xl font-bold uppercase mb-5" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1297">
            Related Links
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1298">
            <Link to="/Calendar.html" className="flex items-center gap-3 p-4 rounded-xl bg-white border shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 group" style={{
            borderColor: '#ede9e0'
          }} data-id="element-1299">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors group-hover:bg-[#1e3d2f]" style={{
              backgroundColor: 'rgba(30,61,47,0.06)'
            }} data-id="element-1300">
                <CalendarDaysIcon size={18} className="transition-colors group-hover:text-white" style={{
                color: '#1e3d2f'
              }} data-id="element-1301" />
              </div>
              <span className="font-semibold text-sm" style={{
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1302">
                View Calendar
              </span>
            </Link>
            <Link to="/PhotoTour.html" className="flex items-center gap-3 p-4 rounded-xl bg-white border shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 group" style={{
            borderColor: '#ede9e0'
          }} data-id="element-1303">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors group-hover:bg-[#1e3d2f]" style={{
              backgroundColor: 'rgba(30,61,47,0.06)'
            }} data-id="element-1304">
                <TargetIcon size={18} className="transition-colors group-hover:text-white" style={{
                color: '#1e3d2f'
              }} data-id="element-1305" />
              </div>
              <span className="font-semibold text-sm" style={{
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1306">
                Firearms Training
              </span>
            </Link>
            <Link to="/ContactUs.html" className="flex items-center gap-3 p-4 rounded-xl bg-white border shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 group" style={{
            borderColor: '#ede9e0'
          }} data-id="element-1307">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors group-hover:bg-[#1e3d2f]" style={{
              backgroundColor: 'rgba(30,61,47,0.06)'
            }} data-id="element-1308">
                <ChevronRightIcon size={18} className="transition-colors group-hover:text-white" style={{
                color: '#1e3d2f'
              }} data-id="element-1309" />
              </div>
              <span className="font-semibold text-sm" style={{
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1310">
                Contact Us
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}